var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('metadata-coap-parameter-extractor-fields',{ref:"fields",attrs:{"tenantId":_vm.tenantId}})}
var staticRenderFns = []

export { render, staticRenderFns }